module.exports = __webpack_public_path__ + "img/weixuanze@2x.93286aea.png";